import { render, staticRenderFns } from "./checkoutPage.vue?vue&type=template&id=6956bdf2&"
import script from "./checkoutPage.vue?vue&type=script&lang=ts&"
export * from "./checkoutPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports